import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import heatmap from 'highcharts/modules/heatmap';

// Initialize the heatmap module
heatmap(Highcharts);

const HeatmapChart = () => {
  // Dummy Data
  const trends = [
    { trend: 'AI Ethics', category: 'Technology', impact: 85 },
    { trend: 'Green Tech', category: 'Environment', impact: 95 },
    { trend: 'Crypto Regulation', category: 'Finance', impact: 75 },
    { trend: 'Remote Work', category: 'Workplace', impact: 88 },
    { trend: 'Supply Chain Issues', category: 'Logistics', impact: 70 },
    { trend: '5G Expansion', category: 'Technology', impact: 92 },
    { trend: 'Climate Policies', category: 'Environment', impact: 77 },
    { trend: 'Quantum Computing', category: 'Technology', impact: 80 },
    { trend: 'Digital Currencies', category: 'Finance', impact: 76 },
    { trend: 'Energy Storage', category: 'Environment', impact: 91 },
  ];

  // Transform the data into a 2D array for the heatmap
  const categories = [...new Set(trends.map((t) => t.category))]; // Unique categories
  const trendNames = trends.map((t) => t.trend); // Trend names

  const data = trends.map((trend, index) => {
    return [categories.indexOf(trend.category), index, trend.impact]; // [x, y, value]
  });

  // Highcharts configuration
  const options = {
    chart: {
      type: 'heatmap',
    },
    title: {
      text: '',
    },
    // subtitle: {
    //   text: 'Visual heatmap of current trends, with colors indicating potential impact levels (e.g., red for high impact).',
    // },
    xAxis: {
      categories: categories, // Categories on the x-axis
      title: {
        text: 'Category',
      },
    },
    yAxis: {
      categories: trendNames, // Trend names on the y-axis
      title: {
        text: 'Trends',
      },
    },
    colorAxis: {
      min: 0,
      max: 100,
      stops: [
        [0, '#3060cf'], // Low impact (blue)
        [0.5, '#fffbbc'], // Medium impact (yellow)
        [1, '#c4463a'], // High impact (red)
      ],
    },
    legend: {
      align: 'right',
      layout: 'vertical',
      margin: 0,
      verticalAlign: 'middle',
      symbolHeight: 200,
    },
    tooltip: {
      formatter: function () {
        return `<b>${this.series.yAxis.categories[this.point.y]}</b><br>
                <b>Category:</b> ${this.series.xAxis.categories[this.point.x]}<br>
                <b>Impact:</b> ${this.point.value}`;
      },
    },
    series: [
      {
        name: 'Trend Impact',
        borderWidth: 1,
        data: data, // Heatmap data
        dataLabels: {
          enabled: true,
          color: '#000',
        },
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default HeatmapChart;
